<template>
  <div id="cardSegmentParam" class="cardSegmentParam" :class="{ selected: isSelected }">
    <b-card class="card-segment"  >
      <div class="img-segment"  @mouseover="mouseOver">
        <div class="image-wrapper-segment">
          <img :src="Shot ? Shot : screenShot" :id="item.id" class="" />
          <div class="image-icon">
            <div class="image-svg d-flex justify-content-between"   >
              <div class="img-svg" v-on:click="updateSegmentInGrapes(item,index)">
                <i class="icon-edit-c white-color-i" ></i>
             </div>
              <div class="img-svg"  v-on:click="duplicateThis(item, index)" >
                <i class="icon-duplicate-c white-color-i"> </i>
              </div>
              <div class="img-svg">
                <b-dropdown size="lg" variant="link" toggle-class="text-decoration-none" no-caret :id="'dropdown-'+indexDropDown">
                  <template v-slot:button-content>
                    <i class="icon-more-c white-color-i"> </i>
                  </template>
                  <b-dropdown-item href="#" v-on:click="editSegment(item)">
                    <svg
                      class="svg mr"
                      xmlns="http://www.w3.org/2000/svg"
                      width="24px"
                      height="24px"
                      viewBox="0 0 11.361 33.412"
                    >
                      <path
                        fill="#000000"
                        d="M37.431,53.379H35.256a.519.519,0,0,0-.1-.074,2.791,2.791,0,0,1-1.671-3.365c.986-4.063,2-8.12,3.007-12.18a12.7,12.7,0,0,0,.3-1.708.4.4,0,0,0-.531-.474,3.214,3.214,0,0,0-.668.231c-.495.207-.976.451-1.474.642A.839.839,0,0,1,33,36.237v-.792a8.973,8.973,0,0,1,1.139-1.307c1.49-1.173,3.007-2.292,4.555-3.412A5.128,5.128,0,0,1,39.75,30.2a2.566,2.566,0,0,1,1.54-.16,2.983,2.983,0,0,1,2.466,3.849q-1.434,5.868-2.88,11.736a15.7,15.7,0,0,0-.334,1.935.378.378,0,0,0,.548.428c.364-.11.708-.287,1.063-.431.428-.187.872-.358,1.3-.521a.628.628,0,0,1,.715.207.668.668,0,0,1,.07.769,2.85,2.85,0,0,1-.411.632,11.1,11.1,0,0,1-1.16,1.119A32,32,0,0,1,37.431,53.379Z"
                        transform="translate(-33 -19.967)"
                      />
                      <path
                        fill="#000000"
                        d="M46.49,8.237a4.1,4.1,0,1,1,2.911-1.2A4.113,4.113,0,0,1,46.49,8.237Z"
                        transform="translate(-39.246 -0.01)"
                      />
                    </svg>
                    Informations
                  </b-dropdown-item>
                  <b-dropdown-item href="#" v-on:click="handleDelete(item)" style="color: red"
                    ><svg
                      class="action-btn mr"
                      width="24px"
                      height="20px"
                      viewBox="0 0 16 20"
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                    >
                      <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                        <path
                          d="M1.14285714,17.7777778 C1.14285714,19.0055556 2.16571429,20 3.42857143,20 L12.5714286,20 C13.8342857,20 14.8571429,19.0055556 14.8571429,17.7777778 L14.8571429,4.44444444 L1.14285714,4.44444444 L1.14285714,17.7777778 Z M16,1.11111111 L12,1.11111111 L10.8571429,0 L5.14285714,0 L4,1.11111111 L0,1.11111111 L0,3.33333333 L16,3.33333333 L16,1.11111111 Z"
                          id="Shape"
                          fill="red"
                          fill-rule="nonzero"
                        ></path>
                      </g>
                    </svg>
                    Supprimer</b-dropdown-item
                  >
                </b-dropdown>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="footer-segment d-flex justify-content-between">
        <div class="resizer-text">
          <span class="title-segment" v-on:click="showSlides(item)">
            {{ this.item.title }}
          </span>
          <div v-if="item.author" style="margin-top: 0.1em;">
            Par <span style="color: #2196f3;"> {{ createdPar() }} </span>
          </div>
        </div>
        <div class="nb-screen">{{ item.screens.length }} {{ $t('screens.screen') }}(s)</div>
      </div>
    </b-card>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

import { HTTP } from '../../core/http/http-token';
import Routing from '../../core/router/router';
import mixin from '../../mixins/Mixin.js';
import mixinGrapesHelpers from '../../mixins/GrapesMixinHelpers';
import postMixin from '../../mixins/PostCssVw';
import mixinGrapesEditors from '../../mixins/GrapesMixinEditors.js';

export default {
  mixins: [mixin, mixinGrapesHelpers, postMixin, mixinGrapesEditors],

  name: 'Card',
  props: {
    index: '',
    title: '',
    author: '',
    keyWords: '',
    Shot: '',
    item: Object,
    haveScreen: Boolean,
    isSelected: Boolean,
    isCollapse2: {
      type: Boolean,
      default: false,
    },
    isEditable: {
      type: Boolean,
      default: true,
    },
    isHover: {
      type: Boolean,
    },
  },
  data() {
    return {
      listSlides: [],
      selectedIds: [],
      selected: '0',
      screenShot:
        'data:image/png;base64,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',
      isEditMode: false,
      titleSlide: this.item.title,
      indexDropDown : 0
    };
  },
  computed: {
    ...mapGetters({
      indexDelete: 'segments/getDeletedSegmentIndex',
      paramsClient: 'getParamsClients',
    }),
  },
  methods: {
    ...mapActions('common', ['setShowIconSave']),

    ...mapActions('slides', ['setCurrentSlide', 'selectSlide', 'resetSelect', 'updateSlide']),

    ...mapActions('segments', [
      'setCurrentSegmentTitle',
      'updateMetadataSegment',
      'setfromRouteBiblio',
      'getSegment',
      'setScreensTosubmitSegment',
      'duplicateBiblioSegment',
      'removeSegmentByUid',
      'setfromRouteAdd',
      'getAuteurs',
      'getSegments',
      'paginatesegment',
      'selectSegment',
      'setCurrentSegment',
      'removeLastSegmentById',
      'updateSegment',
      'setTitle',
      'resetPage',
      'setSegments',
      'setNbrCall',
      'updateSlideInsideSegment',
      'deleteOneSegmentById',
      'deleteSegmentByIdStore',
      'pushSegments',
      'cancelDelete',
    ]),

    createdPar() {
      return this.item.author.firstName;
    },
    mouseOver(){
      this.indexDropDown ++;
    },
    editSegment(item) {
      this.setCurrentSegment(item);
      this.setfromRouteAdd(false);
      this.$router.push({ name: 'EditSegment', params: { id: item.id } });
      let obj = { EditSegment: true, id: item.id };
      parent.postMessage(obj, '*');
    },

    updateSegmentInGrapes(item,index) {

      var iconSave = document.querySelector('.icon-save');
      this.setfromRouteBiblio(true);
      this.setCurrentSegment(item);
      this.listSlides = this.currentSegment.screens;
      this.resetSelect();
      this.listSlides.forEach(selected => {
        this.selectedIds.push(selected.id);
        //for select
        this.setCurrentSlide(selected);
        this.selectSlide(selected);
      });

      this.$router.push({ name: 'segment', params: { type: 'EditSegment',indexSegment:index } });
      this.setShowIconSave(false);
      if (iconSave) {
        iconSave.innerHTML =
          "<span style='font-family:RobotoUep!important;'>" +
          this.$t('template.save_and_exit') +
          '</span>';
        iconSave.classList.remove('icon-selected');
      }

      this.updateCanvasDimensions();
    },

    showSlides(item) {
      this.setCurrentSegment(item);
      eventHub.$emit('showScreen', true);
      this.$root.$emit('bv::show::modal', 'modal-slides', '#a-slides');
    },
    duplicateThis(segment, index) {
      let item = Object.assign({}, segment);
      let nb = 1;
      let indexOf = item.title.search(/\(copie/i);
      let newTitel = '';
      if (indexOf !== -1) {
        let text = segment.title.substring(segment.title.length, indexOf);
        let originTiel = segment.title.substring(indexOf, 0);

        text = text.match(/\d/g);
        if (text && text !== '') nb += parseInt(text.join(''));

        newTitel = originTiel + '(copie' + nb + ')';
      }
      let self = this;
      setTimeout(() => {
        let duration = 0;
        let screensToSubmit = item.screens.map(s => {
          duration += s.options.duration;
          let css = self.fontSizeToVw(s.css);
          css = self.widthHeightToViewport(css);
          let html = self.animationAttributesToClass(s.html);

          let transition = null;
          if (s.options.transition !== 'undefined' && s.options.transition !== '')
            transition = s.options.transition ? s.options.transition : null;
          self.setScreensTosubmitSegment({
            id: s.id,
            template: self.cmdInlineHtml(self.getSanitizedHtml(html), css),
            type: 'Screen' ? 'Disposition' : s.type,
            transition: transition,
            screenShot: s.screenShot,
          });
          /*s.template = self.cmdInlineHtml(self.getSanitizedHtml(html), css);
          s.type = s.type === 'Screen' ? 'Disposition' : s.type;
          s.template = self.cmdInlineHtml(self.getSanitizedHtml(html), css);
          s.options.transition = s.transition;
          s.screenShot = '';*/
          return s;
        });
        let themesIdList = [];
        if (self.item.themes !== null && self.item.themes !== '') {
          self.item.themes.forEach(t => {
            themesIdList.push(t.id);
          });
        }
        let authorId = null;
        if (self.item.author) authorId = self.item.author.id;
        let key = '';
        if (self.item.keyWords !== null && self.item.keyWords !== '')
          if (self.item.keyWords.isArray) {
            key = self.item.keyWords.join();
          }
        var data = {
          screensToSubmit: screensToSubmit,
          title: newTitel ? newTitel : self.item.title + '(copie)',
          duration: duration ? self.SecToTime(duration) : '00:00:30',
          author: authorId,
          keyWords: key ? key : null,
          description: self.item.description ? self.item.description : null,
          themes: themesIdList ? themesIdList : null,
        };
        HTTP(window.ApiToken)
          .post(Routing.generate('api_segmentDisplay_post_add_segment'), {
            id: null,
            data: data,
            client: self.paramsClient.client,
          })
          .then(
            function(response) {
              if (response.data.code === 200) {
                self.$toasted.show('Segment dupliqué', {
                  theme: 'bubble',
                  position: 'top-center',
                  duration: 3000,
                  icon: 'fa-check-circle',
                  className: 'save-toast',
                });

                let segment = {
                  screens: screensToSubmit,
                  title: self.item.title,
                  duration: self.timeToSec(data.duration),
                  type: 'DefaultSegment',
                  id: response.data.segmentId,
                  author: self.item.author ? self.item.author : null,
                  keyWords: self.item.keyWords ? self.item.keyWords : null,
                  description: self.item.description ? self.item.description : null,
                  themes: self.item.themes ? self.item.themes : null,
                };
                self.duplicateBiblioSegment({ segment: segment, index: index });
                self.$router.push({ name: 'ListSegment' });
              }
            },
            function(error) {
              console.error(error);
            },
          );
      }, 100);
    },
    handleDelete(item) {
      let cancel = false;
      let indexDelete = this.indexDelete(item);

      this.$swal
        .fire({
          title: this.$t('modal.delete.title'),
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#f44336',
          cancelButtonColor: '#2196F3',
          confirmButtonText: this.$t('modal.delete.btn_confirm'),
          cancelButtonText: this.$t('modal.delete.btn_cancel'),
          customClass: 'swal-delete',
        })
        .then(result => {
          if (result.value) {
            this.$swal.fire({
              title: 'Supprimé!',
              type: 'success',
              showConfirmButton: false,
              timer: 2000,
            });
            this.deleteSegmentByIdStore(item);
            this.deleteOneSegmentById(item);
          }
        });

      /*
      this.$toasted.show(this.$t('biblioSegment.textDelete'), {
        theme: 'bubble',
        position: 'top-center',
        duration: 4000,
        action: [
          {
            text: 'Annuler',
            onClick: (e, toastObject) => {
              setTimeout(() => {
                this.cancelDelete({ segment: item, index: indexDelete });
                cancel = true;
              }, 100);

              toastObject.goAway(0);
            },
          },
          {
            text: 'X',
            onClick: (e, toastObject) => {
              toastObject.goAway(0);
            },
          },
        ],
      });
      setTimeout(() => {
        if (!cancel) this.deleteOneSegmentById(item);
      }, 4500);
      */
    },
  }
};
</script>

<style lang="scss">
#slide-list-segment {
  text-align: left !important;
}
#slide-list-segment .btn-lg{
  padding: 0 !important;
  font-size: 1rem !important;

}
.title-segment{
  cursor: pointer;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.img-segment {
 // max-width: 300px;
}

.image-wrapper-segment {
  position: relative;
  padding-bottom: 56.2%;
}

.image-wrapper-segment img {
  position: absolute;
  object-fit: cover;
  width: 100%;
  height: 100%;
}

.cardSegmentParam {
  padding-bottom: 1rem;
}
.action-btn:hover {
  cursor: pointer;
}
.mr {
  margin-right: 0.5em;
}
.card-segment {
 // max-width: 300px;
}
.footer-segment {
  //margin-top: 1em;
  flex: 1 1 auto;
  padding: 0.5rem;
  height: 50px;
}

.text-center {
  text-align: center !important;
}
#slide-list-segment .card-body {
  padding-bottom:0!important;
  padding-top: 0;
  padding-left: 0;
  padding-right: 0;
}
.action-segment,
.apercu {
  display: none;
}

#slide-list-segment .card {
  border: none;

  &:hover {
    box-shadow: 0px 0px 0px 1px rgba(0,0,0,0.1);
    .action-segment {
      display: block;
    }
    .apercu {
      display: block;
      cursor: pointer;
    }
    .img-fluid {
      filter: blur(2px);
    }
  }
  &.selected {
    box-shadow: 0px 0px 0px 1px rgba(0,0,0,0.1);
    .action-segment {
      display: block;
    }
  }
}
.apercu {
  position: absolute;
  top: 40%;
  left: 45%;
}
.image-icon {
  display: none;
  position: absolute;
  background-color: rgba(0, 0, 0, 0.52);
  height: 100%;
  width: 100%;
  text-align: center;
   .image-svg{
    position: relative;
    display: flex;
    justify-content: center;
    width: 100%;
    align-items: center;
      .img-svg{
      cursor: pointer;
      margin: 5%;
      .svg{
        position: relative;
        top: 25%;
      }
    }
  }
}
.img-segment:hover {
  ::v-deep .dropdown-menu {
    display: none;
  }
  .image-icon {
    display: flex !important;
  }
}
.resizer-text {
  cursor: pointer;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.nb-screen {
  border: 1px solid;
  border-radius: 25px;
  padding-left: 5px;
  padding-right: 5px;
  padding-top: 2px;
  margin: 5px;
  font-size: 13px;
  cursor: pointer;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.white-color-i {
  color: white;
  font-size: 2em;
}
</style>



// WEBPACK FOOTER //
// Card.vue?32ef0f05